export const getAreaPct = ({
  area,
  totalArea,
}: {
  area: number | undefined | null;
  totalArea: number | undefined | null;
}): null | number => {
  if (typeof area !== 'number' || typeof totalArea !== 'number' || totalArea === 0) {
    return null;
  }

  return (area / totalArea) * 100;
};
